// ============================================================
// Client Connect · layout chrome — wraps /connect/:projectSlug/*
//
// This is the CLIENT shell, intentionally NOT the operator MainframeShell:
// no operator sidebar, no operator nav, no diagnostics. It only renders
// behind a PASSING ClientAccessGate (closed for everyone in Phase 1), so
// in Phase 1 it is effectively unreachable — it exists so Phase 2 can
// light up Client Connect without restructuring the router.
//
// Client-facing language only.
// ============================================================

import { NavLink, Outlet, useParams } from 'react-router-dom'
import { SHELL_TOKENS } from '../../shell/styles'

const TABS: { to: string; label: string; end?: boolean }[] = [
  { to: '', label: 'Workspace', end: true },
  { to: 'messages', label: 'Messages' },
  { to: 'files', label: 'Files' },
  { to: 'deliverables', label: 'Deliverables' },
  { to: 'tasks', label: 'Tasks' },
  { to: 'calendar', label: 'Calendar' },
  { to: 'testing', label: 'Previews' },
  { to: 'approvals', label: 'Approvals' },
]

export default function ConnectLayout() {
  const { projectSlug } = useParams<{ projectSlug: string }>()
  const base = `/connect/${projectSlug ?? ''}`

  return (
    <div style={{ minHeight: '100vh', background: 'var(--olv-void, #000)', color: SHELL_TOKENS.ink }}>
      <header
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          padding: '16px 24px',
          borderBottom: `1px solid ${SHELL_TOKENS.borderAlt}`,
        }}
      >
        <div style={{ fontSize: 15, fontWeight: 700, letterSpacing: '0.02em', fontFamily: 'var(--font-brand)' }}>
          Client Connect
        </div>
        <div style={{ fontSize: 12, color: SHELL_TOKENS.inkFaint, fontFamily: 'var(--font-mono)' }}>
          {projectSlug}
        </div>
      </header>

      <nav
        style={{
          display: 'flex',
          gap: 4,
          padding: '12px 24px',
          borderBottom: `1px solid ${SHELL_TOKENS.border}`,
          flexWrap: 'wrap',
        }}
      >
        {TABS.map((t) => (
          <NavLink
            key={t.label}
            to={t.to ? `${base}/${t.to}` : base}
            end={t.end}
            style={({ isActive }) => ({
              padding: '8px 14px',
              borderRadius: 8,
              fontSize: 13,
              fontWeight: isActive ? 700 : 500,
              textDecoration: 'none',
              color: isActive ? SHELL_TOKENS.brand : SHELL_TOKENS.inkDim,
              background: isActive ? SHELL_TOKENS.brandSoft : 'transparent',
              border: `1px solid ${isActive ? SHELL_TOKENS.brandLine : 'transparent'}`,
            })}
          >
            {t.label}
          </NavLink>
        ))}
      </nav>

      <main style={{ maxWidth: 880, margin: '0 auto' }}>
        <Outlet />
      </main>
    </div>
  )
}
